import script from "./CheckPermissions.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckPermissions.vue?vue&type=script&setup=true&lang=ts"

import "./CheckPermissions.vue?vue&type=style&index=0&id=76f175b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f175b2"]])

export default __exports__